<template>
  <div class="all">
    <div class="searchtop">
      <div class="searchtop-title">筛选查询</div>
      <el-button type="primary"
                 class="seniorbuton"
                 @click="seniorShowClick">高级搜索</el-button>
      <el-button type="primary"
                 class="seniorbuton"
                 v-if="seniorshow"
                 style="margin-right: 10px"
                 @click="seniorHiddenClick"
                 plain>收起筛选</el-button>
    </div>
    <el-form label-width="80px"
             style="margin-top: 5px"
             :model="dataForm">
      <el-row :gutter="24">
        <el-col :span="6">
          <!-- todo -->
          <el-form-item label="客户名称">
            <el-input v-model="dataForm.name"
                      placeholder="客户名称"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="认证企业">
            <el-select v-model="dataForm.companyCode"
                       placeholder="请选择">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="提交时间">
            <el-date-picker v-model="valueTime"
                            type="daterange"
                            style="width: 120%"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-button style="float: right; margin-right: 10px">重置</el-button>
          <el-button type="primary"
                     style="float: right; margin-right: 10px">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-width="80px"
             style="margin-top: 5px"
             v-show="seniorshow"
             :model="dataForm">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="客户账号">
            <el-input v-model="dataForm.userName"
                      placeholder="客户账号"
                      style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="认证类型">
            <el-select v-model="dataForm.authentTypeCode"
                       placeholder="请选择">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="企业性质">
            <el-select v-model="dataForm.nature"
                       placeholder="请选择">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态">
            <el-select v-model="dataForm.enableStatus"
                       placeholder="请选择">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button type="primary"
               size="mini"
               @click="addPerson"
               style="margin-right: 10px">新增客户</el-button>
    <div class="allnumber">
      待认证 8 项 。 | 总计 36328 项 ，已认证 36320 项 。
    </div>
    <el-table :data="tableData"
              border
              style="width: 100%">
      <el-table-column type="index"
                       label="序号"
                       fixed
                       width="50">
      </el-table-column>
      <el-table-column fixed
                       prop="userName"
                       label="客户账号"
                       width="150">
      </el-table-column>
      <el-table-column prop="name"
                       label="客户名称"
                       width="120">
      </el-table-column>
      <el-table-column prop="authentTypeName"
                       label="认证企业"
                       min-width="300">
      </el-table-column>
      <el-table-column prop="submitTime"
                       label="提交时间"
                       width="120">
      </el-table-column>
      <el-table-column prop="authentTypeName"
                       label="认证类型"
                       width="300">
      </el-table-column>
      <!-- TODO -->
      <el-table-column prop="nature"
                       label="企业性质"
                       width="120">
      </el-table-column>
      <!-- TODO -->
      <el-table-column prop="enableStatus"
                       label="状态"
                       width="120"> </el-table-column>
      <el-table-column fixed="right"
                       label="操作"
                       width="80">
        <template slot-scope="scope">
          <el-button @click="goCheck(scope.row)"
                     type="text"
                     size="small">查看</el-button>
          <el-dropdown trigger="click">
            <span class="el-dropdown-link"
                  style="cursor: pointer">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="doDelete(scope.row)">删除</el-dropdown-item>
              <el-dropdown-item @click.native="doOverrule(scope.row)">驳回</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="page"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="limit"
                   :total="total"
                   layout="total, sizes, prev, pager, next, jumper"
                   @size-change="pageSizeChangeHandle"
                   @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/log/login/page',
        getDataListIsPage: true,
        exportURL: '/sys/log/login/export'
      },
      dataForm: {},
      // modifyStartTime, modifyEndTime
      // 提交时间
      valueTime: [],
      seniorshow: false,
      value1: [],
      options: [
        {
          value: '选项1',
          label: '北京烤鸭'
        },
        {
          value: '选项2',
          label: '北京烤鸭'
        },
        {
          value: '选项3',
          label: '北京烤鸭'
        },
        {
          value: '选项4',
          label: '北京烤鸭'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      tableData: [
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333
        }
      ]
    }
  },
  methods: {
    seniorShowClick () {
      this.seniorshow = true
    },
    // 增加用户
    addPerson () {
      this.$router.push({
        name: 'sys-enterprise-certification-addperson'
      })
    },
    seniorHiddenClick () {
      this.seniorshow = false
    },
    goCheck (row) {
      this.$router.push({
        name: 'sys-enterprise-certification-check'
      })
    },
    goAttestation () {
      this.$router.push({
        name: 'sys-enterprise-certification-attestation'
      })
    },
    // 删除
    doDelete (val) {
      this.$confirm('确定要删除该用户企业认证申请吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        this.$http.post('/help/user/sys/custCompany/delete', {
          companyId: val.companyId
        }, {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic cmVucmVuaW86cmVucmVuaW8='
          }
        }).then(({ data: res }) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getDateList()
          }
        }).catch(() => { })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 驳回
    doOverrule (val) {
      this.$confirm('确定要驳回该用户企业认证申请吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        this.$http.post('/help/user/sys/custCompany/submitAudit', {
          companyId: val.companyId,
          authentFlag: '30'
        }, {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic cmVucmVuaW86cmVucmVuaW8='
          }
        }).then(({ data: res }) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '驳回成功!'
            })
            this.getDateList()
          }
        }).catch(() => { })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消驳回'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.searchtop {
  height: 40px;
  width: 100%;
  line-height: 40px;
  background-color: #f3f3f3;
  padding-left: 20px;
  padding-right: 20px;
  border: 1px solid #dcdfe6;
  .searchtop-title {
    line-height: 40px;
    color: #303133;
    float: left;
  }
  .seniorbuton {
    margin-top: 5px;
    float: right;
  }
}
.allnumber {
  width: 100%;
  height: 25px;
  line-height: 25px;
  background-color: #e2f3fc;
  margin-top: 5px;
  font-size: 12px;
  padding-left: 20px;
  color: #606266;
}
</style>
<style>
.searchtop .el-button {
  height: 30px;
  padding: 5px 10px;
}
</style>
